import { render, staticRenderFns } from "./FormDocumentDetail.vue?vue&type=template&id=45f52c4c&scoped=true&"
import script from "./FormDocumentDetail.vue?vue&type=script&lang=js&"
export * from "./FormDocumentDetail.vue?vue&type=script&lang=js&"
import style0 from "./FormDocumentDetail.vue?vue&type=style&index=0&id=45f52c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f52c4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f52c4c')) {
      api.createRecord('45f52c4c', component.options)
    } else {
      api.reload('45f52c4c', component.options)
    }
    module.hot.accept("./FormDocumentDetail.vue?vue&type=template&id=45f52c4c&scoped=true&", function () {
      api.rerender('45f52c4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/documents/FormDocumentDetail.vue"
export default component.exports